const regenerate = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g id="Ic_Regenerate">
        <g id="Group">
          <path
            id="Ellipse 3"
            d="M17.4735 9.36935C17.9321 9.33065 18.3397 9.67163 18.3324 10.1318C18.3071 11.7297 17.8225 13.2933 16.9278 14.6316C15.8781 16.2017 14.3262 17.3687 12.5263 17.9413C10.7265 18.5138 8.78557 18.458 7.02162 17.783C5.51812 17.2076 4.21922 16.2114 3.27538 14.9218C3.00356 14.5504 3.13918 14.0366 3.53586 13.8032C3.93254 13.5698 4.4394 13.7062 4.72042 14.0707C5.46607 15.0378 6.46681 15.7861 7.61731 16.2264C9.02847 16.7664 10.5812 16.8111 12.0211 16.353C13.461 15.895 14.7025 14.9614 15.5423 13.7053C16.2269 12.6812 16.6114 11.4923 16.6612 10.2721C16.68 9.8122 17.0149 9.40806 17.4735 9.36935Z"
            fill="#EBB268"
          />
          <path
            id="Ellipse 4"
            d="M2.52673 10.6309C2.06812 10.6696 1.66059 10.3286 1.66786 9.86843C1.6931 8.2705 2.1777 6.70697 3.07242 5.36866C4.12213 3.79852 5.67407 2.63154 7.4739 2.05898C9.27373 1.48641 11.2147 1.54223 12.9786 2.21729C14.4821 2.79267 15.781 3.78883 16.7249 5.07848C16.9967 5.44988 16.8611 5.96365 16.4644 6.19703C16.0677 6.43041 15.5608 6.29406 15.2798 5.92957C14.5342 4.96243 13.5334 4.21415 12.3829 3.77386C10.9718 3.23382 9.41902 3.18916 7.97915 3.64721C6.53929 4.10527 5.29773 5.03885 4.45797 6.29496C3.77332 7.31905 3.38885 8.50799 3.33904 9.72819C3.32026 10.188 2.98534 10.5922 2.52673 10.6309Z"
            fill="#EBB268"
          />
          <path
            id="Vector"
            d="M6.66667 13.7501L3.33333 12.9167L2.5 16.2501"
            stroke="#EBB268"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_2"
            d="M13.3335 6.25L16.6668 7.08333L17.5002 3.75"
            stroke="#EBB268"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default regenerate;
